import styled from 'styled-components';

export const ScoreValue = styled.div`
    font-size: ${({theme}) => theme.fontSize.m};
    font-weight: ${({theme}) => theme.fontWeight.semiBold};
`;

export const ScoreText = styled.div`
    font-size: ${({theme}) => theme.fontSize.s};
    font-weight: ${({theme}) => theme.fontWeight.regular};
`;
